import { FC } from 'react';

import { RootState } from 'store/rootReducer';

import { useAppSelector } from 'hooks/defaultStoreHooks';

import { DrawerSection } from 'components/drawerSections/DrawerSections';
import ShareButton from 'components/share/ShareButton';

import { Aktivitet } from 'models';

import { formatDate } from 'utilities/dateUtilities';
import { isSkyddsklassningsaktivitet } from 'utilities/typeGuards';

const AktivitetBaseInfo: FC<{ aktivitet: Aktivitet }> = ({ aktivitet }) => {
  const { data: aktivitetDomaner } = useAppSelector((state: RootState) => state.aktivitetDomaner);

  return (
    <DrawerSection>
      <ShareButton />
      <h1 className="tw-heading-lg tw-mb-6">
        {aktivitet &&
          (isSkyddsklassningsaktivitet(aktivitet) ? aktivitet.skyddsklassningstyp_namn : aktivitet.aktivitetsnamn)}
      </h1>
      <p className="tw-mb-4">
        {isSkyddsklassningsaktivitet(aktivitet)
          ? aktivitetDomaner?.skyddsklassningsaktiviteter.find(
              (skyddsklassningsaktivitettyp) => skyddsklassningsaktivitettyp.id === aktivitet?.skyddsklassningstyp_id
            )?.beskrivning
          : aktivitetDomaner?.aktivitettyper.find(
              (aktivitettyp) => aktivitettyp.aktivitettyp === aktivitet?.aktivitetstyp
            )?.beskrivning}
      </p>
      <ul className="tw-mt-8">
        <li>
          <span id="aktivitet-id" className="tw-font-semibold">
            Aktivitetsnummer:{' '}
          </span>
          <span aria-labelledby="aktivitet-id">{aktivitet?.aktivitetsnummer}</span>
        </li>
        <li>
          <span id="utforande-organisation" className="tw-font-semibold">
            Utförande organisation:{' '}
          </span>
          <span aria-labelledby="utforande-organisation">{aktivitet?.ansvarig_organisation?.organisationsnamn}</span>
        </li>
        <li>
          <span id="registreringsdatum" className="tw-font-semibold">
            Registreringsdatum:{' '}
          </span>
          <span aria-labelledby="registreringsdatum">{formatDate(aktivitet?.aktivitetstatus.status_datum)}</span>
        </li>
      </ul>
    </DrawerSection>
  );
};

export default AktivitetBaseInfo;
